import { render, staticRenderFns } from "./MemberApprovalManage.vue?vue&type=template&id=34646104&scoped=true&"
import script from "./MemberApprovalManage.vue?vue&type=script&lang=js&"
export * from "./MemberApprovalManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34646104",
  null
  
)

export default component.exports